import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { Text } from 'components/base'
import Confirm from 'components/Utils/Modal/Confirm'
import { makeToggleable } from 'components/Utils/toggleable'
import UsersApi from 'remote/users'

import { selectors as AuthSelectors } from 'data/auth'
import { selectors as ConfigSelectors } from 'data/config'

class UserRemoveAccount extends React.PureComponent {
  typeformPopupClosedHandle = null

  constructor(props) {
    super(props)

    this.removeAccount = this.removeAccount.bind(this)
  }

  displayTypeform = () => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://embed.typeform.com/embed.js'
    script.addEventListener('load', () => {
      // @ts-ignore
      window.typeformEmbed.makePopup('https://slite.typeform.com/to/Ngahvv', {
        autoOpen: true,
        hideFooter: true,
        hideHeaders: true,
      })

      // the Typeform API doesn't offer a way to tell when the popup is closed
      // We therefore need to track it ourselves.
      this.typeformPopupClosedHandle = setInterval(() => {
        const iframeElement = document.querySelector('iframe[src*=typeform]')

        if (!iframeElement) {
          this.props.onRemove({ success: true })
          clearInterval(this.typeformPopupClosedHandle)
        }
      }, 300)
    })

    document.body.appendChild(script)
  }

  async removeAccount(event) {
    const { closeModal, onRemove, apiToken, apiEndpoint } = this.props

    const success = await UsersApi.backupAndArchiveMe({
      apiToken,
      apiEndpoint,
    })

    if (success === false) {
      return onRemove({ success })
    }

    closeModal(event)
    this.displayTypeform()
  }

  componentWillUnmount() {
    clearInterval(this.typeformPopupClosedHandle)

    if (this.script) {
      this.script.remove()
      this.script = null
    }
  }

  render() {
    const { openModal, isModalOpen, closeModal, children } = this.props

    return (
      <div>
        <Confirm
          show={isModalOpen}
          onConfirm={this.removeAccount}
          onCancel={closeModal}
        >
          <div className="text-align-left">
            <Text.Subtitle style={{ lineHeight: '30px' }}>
              Are you sure you want to delete your account?
            </Text.Subtitle>

            <Text.SmallDetail
              style={{ lineHeight: '16px' }}
              className="margin-top-medium"
            >
              Once confirmed, this action will be effective immediately and
              you’ll lose access to all your account and team data.
            </Text.SmallDetail>
          </div>
        </Confirm>
        <div onClick={openModal}>{children}</div>
      </div>
    )
  }
}

const ConnectedUserRemovalModal = compose(
  makeToggleable({
    attrName: 'isModalOpen',
    toggleOnName: 'openModal',
    toggleOffName: 'closeModal',
    toggleName: 'toggleModal',
    defaultValue: false,
  }),
  connect(state => {
    return {
      apiToken: AuthSelectors.getApiToken(state),
      apiEndpoint: ConfigSelectors.getApiEndpoint(state),
    }
  })
)(UserRemoveAccount)

ConnectedUserRemovalModal.propTypes = {
  onRemove: PropTypes.func.isRequired,
}

ConnectedUserRemovalModal.defaultProps = {
  onRemove: () => {},
}

export default ConnectedUserRemovalModal
